// Centralized configuration for all PageEmptyState instances across the app.
// Each key maps to { imageSrc, message, subMessage } used by PageEmptyState.

import NoClientsIcon from "../assets/images/empty_states/clients_dashboard_empty_state.svg";
import NoOrdersIcon from "../assets/images/empty_states/orders_mng_empty_state.svg";
import NoEmpIcon from "../assets/images/empty_states/employee_dashboard_empty_state.svg";
import BookServiceEmptyStateImg from "../assets/images/empty_states/book_service_empty_state.svg";
import BillingEmptyStateImg from "../assets/images/empty_states/billing_empty_state.svg";
import VaultEmptyStateImg from "../assets/images/empty_states/vault_empty_state.svg";
import ClientVaultEmptyStateImg from "../assets/images/empty_states/client_vault_empty_state.svg";
import DocMngEmptyStateImg from "../assets/images/empty_states/document_mng_empty_state.svg";
import NotificationsEmptyStateImg from "../assets/images/empty_states/notifications_empty_state.svg";
import ReferMngEmptyStateImg from "../assets/images/empty_states/refer_mng_empty_state.svg";
import MyCalendarEmptyStateImg from "../assets/images/empty_states/my_calendar_empty_state.svg";
import ComplianceCalendarEmptyStateImg from "../assets/images/empty_states/compliance_calendar_empty_state.svg";
import DepartmentsEmptyStateImg from "../assets/images/empty_states/departments_empty_state.svg";

const EMPTY_STATE_CONFIG = {
  CLIENTS: {
    imageSrc: NoClientsIcon,
    message: "No Clients",
    subMessage: "Clients and customer records will appear here once added.",
  },
  ORDERS: {
    imageSrc: NoOrdersIcon,
    message: "No Orders",
    subMessage: "Orders and purchases will appear here once created.",
  },
  EMPLOYEES: {
    imageSrc: NoEmpIcon,
    message: "No Employees",
    subMessage: "Employees and team members will appear here once added.",
  },
  MY_SERVICES: {
    imageSrc: BookServiceEmptyStateImg,
    message: "Get Started With our Services",
    subMessage: "Buy or Request a callback to one of our services. Get an Expert assisted Services.",
  },
  BILLING_AGENT: {
    imageSrc: BillingEmptyStateImg,
    message: "No Bills",
    subMessage: "Bills and invoices will appear here once generated.",
  },
  BILLING_CLIENT: {
    imageSrc: BookServiceEmptyStateImg,
    message: "There's No Billing. Buy a Service to get One.",
    subMessage: "Buy or Request a callback to our services. Get an Expert assisted Services.",
  },
  VAULT: {
    imageSrc: VaultEmptyStateImg,
    message: "No Vault Password",
    subMessage: "",
  },
  VAULT_CREATE: {
    imageSrc: VaultEmptyStateImg,
    message: "Create Vault Password",
    subMessage: "Secure your vault by creating a strong password.",
  },
  CLIENT_VAULT: {
    imageSrc: ClientVaultEmptyStateImg,
    message: "No Client Vault",
    subMessage: "Secure client vault files will appear here once added.",
  },
  DOCUMENTS: {
    imageSrc: DocMngEmptyStateImg,
    message: "No Service Document",
    subMessage: "Service documents and files will appear here once a Service is Completed.",
  },
  NOTIFICATIONS: {
    imageSrc: NotificationsEmptyStateImg,
    message: "There is no Notifications",
    subMessage: "",
  },
  NOTIFICATIONS_CLIENT: {
    imageSrc: NotificationsEmptyStateImg,
    message: "There is no Notifications",
    subMessage: "Buy or Request a callback to our services. Get an Expert assisted Services.",
  },
  REFERRALS_AGENT: {
    imageSrc: ReferMngEmptyStateImg,
    message: "No Client Referrals",
    subMessage: "Client referrals and invites will appear here once added.",
  },
  REFERRALS_CLIENT: {
    imageSrc: ReferMngEmptyStateImg,
    message: "No Referrals",
    subMessage: "There are No referrals, Referrals will appear here once Invited.",
  },
  MY_CALENDAR: {
    imageSrc: MyCalendarEmptyStateImg,
    message: "No Calendar Reminder",
    subMessage: "Calendar reminders and alerts will appear here once added.",
  },
  COMPLIANCE_CALENDAR: {
    imageSrc: ComplianceCalendarEmptyStateImg,
    message: "No Compliance",
    subMessage: "Compliance schedules and reminders will appear here.",
  },
  DEPARTMENTS: {
    imageSrc: DepartmentsEmptyStateImg,
    message: "No Department",
    subMessage: "Departments and teams will appear here once created.",
  },
};

export default EMPTY_STATE_CONFIG;
